import MagnifierIcon from "../assets/icons/icon-cool/Magnifier.svg";
import NotebookIcon from "../assets/icons/icon-cool/Notebook.svg";
import UserIcon from "../assets/icons/icon-cool/User.svg";
import WorldIcon from "../assets/icons/icon-cool/World.svg";

interface Item {
  link: string;
  title: string;
  icon?: string;
  active: boolean;
  children?: Item[];
}

const desktopMenu: Item[] = [
  {
    link: "/cursos/list",
    title: "Buscar",
    active: true,
    icon: MagnifierIcon,
  },
  {
    link: "/mis-cursos/list",
    title: "Mis Cursos",
    active: true,
    icon: NotebookIcon,
  }
];

const mobileMenu: Item[] = [
  {
    link: "/cursos/list",
    title: "Buscar",
    active: true,
    icon: MagnifierIcon,
  },
  {
    link: "/mis-cursos/list",
    title: "Mis Cursos",
    active: true,
    icon: NotebookIcon,
  },
  // {
  //   link: "/comunidad",
  //   title: "Comunidad",
  //   active: true,
  //   icon: WorldIcon,
  // },
  {
    link: "/mi-perfil",
    title: "Mi perfíl",
    active: true,
    icon: UserIcon,
  }
];

const menu = {
  mobileMenu,
  desktopMenu
}

export default menu;
